<template>
  <div id="container">
    <div class="loading-pic" v-if="loading">
      <img src="spinner.svg" alt="loading" />
    </div>
    <div class="backstep" @click="phoneReturn">
      <i class="fas fa-long-arrow-alt-left"></i>
    </div>
    <div class="fit-size"></div>
    <h2>{{ trad.pageEnd.title }}</h2>
    <h3>{{ trad.pageEnd.firstname }}{{ demoProgression[0].firstname }}</h3>
    <h3>{{ trad.pageEnd.lastname }}{{ demoProgression[0].name }}</h3>
    <h3><i class="far fa-envelope"></i> : {{ demoProgression[0].mail }}</h3>
    <h3><i class="fas fa-mobile-alt"></i> : {{ demoProgression[0].phone }}</h3>
    <br />
    <button @click="sendClicked">{{ trad.pageEnd.button }}</button>
    <br />
    <img class="help-pic" :src="help[randPic]" alt="Help-pic" />
    <div class="help-container">
      <div class="talk-bubble tri-right round btm-left">
        <div class="talktext">
          <p>{{ trad.pageEnd.help }}</p>
        </div>
      </div>
    </div>

    <div class="succes-msg">
      <div class="container-pic">
        <i class="far fa-envelope"></i>
        <p>{{ trad.pageEnd.success.text }}</p>
      </div>
      <div class="container-txt">
        <div id="btn-final">
          <a @click="inscription" class="btn-inscription">{{
            trad.pageEnd.success.inscriptionButton
          }}</a>
          <a @click="appointment" class="btn-appointment">{{
            trad.pageEnd.success.makeAnAppointment
          }}</a>
        </div>
        <a class="btn-home" :href="trad.pageEnd.success.urlHomeButton">{{
          trad.pageEnd.success.homeButton
        }}</a>
      </div>
    </div>

    <div class="error-msg">
      <div class="container-pic">
        <i class="fas fa-exclamation-triangle"></i>
        <p>{{ trad.pageEnd.error.text }}</p>
      </div>
      <div class="container-txt">
        <a class="btn-home" :href="trad.pageEnd.error.urlHomeButton">{{
          trad.pageEnd.error.homeButton
        }}</a>
      </div>
    </div>
  </div>
</template>

<script>

import axios from "axios";

export default {
  name: "WelcomePhoneCheck",
  data() {
    return {
      checked: false,
      checkedError: false,
      trad: this.langTxt,
      help: ["help0.png", "help1.png", "help2.png", "help3.png", "help4.png"],
      loading: false,
    };
  },
  props: ["demoProgression", "randPic","langTxt"],
  created: function() {
    window.scrollTo(0, document.body.scrollHeight - 20);
  },
  methods: {
    inscription() {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const gclidParameter = urlParams.get("gclid");
      const sourceParameter = urlParams.get("source");

      let finalUri = this.trad.pageEnd.success.urlInscription + "/" +
        this.trad.promoCode + "/" +
        this.demoProgression[0].mail + "/" +
        this.demoProgression[0].firstname + "/" +
        this.demoProgression[0].name + "/" +
        this.demoProgression[0].phone.replace(/ /g, "");

      if( null !== gclidParameter && "" !== gclidParameter )
      {
          finalUri = finalUri + "&gclid=" + gclidParameter;
      }

      if( null !== sourceParameter && "" !== sourceParameter )
      {
          finalUri = finalUri + "&source=" + sourceParameter;
      }

      window.location = finalUri;
    },
    appointment() {
      window.open( this.trad.pageEnd.success.urlAppointment, "_blank" );    
    },
    phoneReturn() {
      if (this.demoProgression[0].completedName) {
        this.demoProgression[0].demoStart = true;
        this.demoProgression[0].completedMail = true;
        this.demoProgression[0].completedName = true;
        this.demoProgression[0].completedPhone = false;
        this.demoProgression[0].sendClicked = false;
        this.demoProgression[0].preview = false;
      }
    },
    sendClicked(e) {
      e.preventDefault();

      this.checked = true;
      this.demoProgression[0].sendClicked = this.checked;
      this.loading = true;

      this.$emit("send-clicked", this.demoProgression);

      let sendParams = {
        firstname: this.demoProgression[0].firstname,
        lastname: this.demoProgression[0].name,
        email: this.demoProgression[0].mail,
        phone: this.demoProgression[0].phone.replace(/ /g, ""),
        // "randomNumber": localStorage.getItem('randomNumber').replace(/\n|\r/g,'')
      };

      let myNewJSON = JSON.stringify(sendParams);

      axios
        .post("./php/require/api.php", myNewJSON)
        .then(function(res) {
          if (res.data.request_id) {
            document.querySelector(".loading-pic").style.display = "none";
            let succesMsg = document.querySelector(".succes-msg");
            succesMsg.classList.add("succes-show");
          } else {
            document.querySelector(".loading-pic").style.display = "none";
            let errorMsg = document.querySelector(".error-msg");
            errorMsg.classList.add("error-show");
          }
        })
        .catch(function() {
          document.querySelector(".loading-pic").style.display = "none";
          let errorMsg = document.querySelector(".error-msg");
          errorMsg.classList.add("error-show");
        });
    },
  },
};
</script>

<style scoped>
#container {
  padding: 40px;
  padding-top: 45px;
  box-shadow: 10px 10px 20px 0px rgba(133, 133, 133, 0.55);
  margin: auto;
  width: fit-content;
  height: 525px;
  margin-top: 15px;
  border-radius: 10px;
  position: relative;
}
.fit-size {
  width: 375px;
}
.mob-center {
  text-align: center;
}
p {
  border-radius: 15px;
  border: none;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  color: rgb(59, 59, 59);
}
button {
  width: 115px;
  height: 40px;
  background-color: #7C9048;
  color: white;
  font-size: 20px;
  font-weight: bold;
  border-radius: 10px;
  margin-top: 20px;
  cursor: pointer;
  border: none;
  font-family: Avenir, Helvetica, Arial, sans-serif;
}
h2 {
  margin: 25px;
  margin-top: 5px;
}
h3 {
  text-align: left;
}
h3 i {
  font-size: 22px;
}

.loading-pic {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 3000;
}

/* Start Help User */

.help-container {
  position: absolute;
  width: fit-content;
  height: fit-content;
  bottom: 95px;
  left: 90px;
}
.help-pic {
  width: 125px;
  position: absolute;
  left: -5px;
  bottom: -15px;
}
.talk-bubble {
  display: inline-block;
  position: relative;
  width: 300px;
  height: auto;
  background-color: #f9f9db;
}
.border {
  border: 8px solid #666;
}
.round {
  border-radius: 30px;
  -webkit-border-radius: 30px;
  -moz-border-radius: 30px;
}
.tri-right.border.btm-left:before {
  content: " ";
  position: absolute;
  width: 0;
  height: 0;
  left: -8px;
  right: auto;
  top: auto;
  bottom: -40px;
  border: 32px solid;
  border-color: transparent transparent transparent #666;
}
.tri-right.btm-left:after {
  content: " ";
  position: absolute;
  width: 0;
  height: 0;
  left: 0px;
  right: auto;
  top: auto;
  bottom: -20px;
  border: 22px solid;
  border-color: transparent transparent transparent #f9f9db;
}
.talktext {
  padding: 1em;
  text-align: left;
  line-height: 1.5em;
}
.talktext p {
  -webkit-margin-before: 0em;
  -webkit-margin-after: 0em;
  font-weight: 500;
}

/* End Help User */

/* Start Ending Message */

.error-msg,
.succes-msg {
  display: none;
}
.error-show,
.succes-show {
  display: block !important;
  background: gray;
  position: absolute;
  top: 25%;
  left: -25%;
  width: 150%;
  height: 60%;
  border-radius: 6px;
  box-shadow: 10px 10px 20px 0px rgba(88, 88, 88, 0.55);
  z-index: 15;
}
.error-show .container-pic {
  background: rgb(85, 3, 3);
}
.container-pic {
  background: #3F608E;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 70%;
  border-radius: 6px 6px 0px 0px;
  color: white;
  font-weight: bold;
  font-size: 64px;
}
.container-pic p {
  color: white !important;
  font-weight: bold !important;
  margin-top: 15px;
}
.container-txt {
  background: white;
  width: 100%;
  height: 30%;
  border-radius: 0px 0px 6px 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.btn-home {
  color: #9f9f9f;
  margin-top: 20px;
}

.btn-inscription {
  padding: 8px;
  background: #3F608E;
  color: white;
  font-weight: bold;
  border-radius: 6px;
  margin: 10px;
  cursor: pointer !important;
}

.btn-appointment {
  padding: 8px;
  background: #8A9E54;
  color: white;
  font-weight: bold;
  border-radius: 6px;
  margin: 10px;
  cursor: pointer !important;
}

/* !dm @ 20210105 */
#btn-final {
  display: inline-block;
  margin-top: 10px;
}
/* End Ending Message */

@media screen and (max-width: 1600px) {
  .succes-show,
  .error-show {
    top: 7.5%;
  }
}

@media screen and (max-width: 800px) {
  #container {
    width: 100%;
  }
  .succes-show,
  .error-show {
    top: 10%;
    left: 0px;
    width: 100%;
  }
  .container-pic p {
    padding: 0 5px;
  }
  .fit-size {
    width: 90%;
  }
  .talk-bubble {
    width: 225px;
  }
  img {
    z-index: -2;
  }
}
@media screen and (max-width: 400px) {
  #container {
    height: 72vh;
  }
}

@media screen and (max-width: 380px) and (max-height: 680px) {
  #container {
    width: 100%;
    height: 85vh;
    padding: 30px;
    padding-top: 45px;
  }
  .error-show {
    top: 38%;
  }
}

@media screen and (max-width: 325px) and (max-height: 600px) {
        #container {
            width: 100%;
            height: 95vh;
        }
        .error-show {
            top: 0%;
        }
    }
</style>
